<template>
    <aside class="sidenav bg-white navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-4 " id="sidenav-main">
        <div class="sidenav-header">
            <i class="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
            <div class="d-flex justify-content-between">
                <div class="navbar-brand m-0">
                    <img :src="baseUrl + 'favicon.png'" class="navbar-brand-img h-100 pe-2" alt="main_logo">
                    <span class="ms-1 font-weight-bold">
                        {{ this.appTitle }}
                    </span>
                </div>
                <div class="navbar-brand mt-1" @click="this.toggleSidebar()">
                    <span class="ms-1 font-weight-bold">
                        <font-awesome-icon icon="close"></font-awesome-icon>
                    </span>
                </div>
            </div>
        </div>
        <hr class="horizontal dark mt-0">
        <div class="collapse navbar-collapse w-auto h-auto" id="sidenav-collapse-main" @click="this.toggleSidebar()">
            <sidebar :roles="this.roles"></sidebar>
        </div>
    </aside>
    <main class="main-content position-relative max-height-vh-100 h-100 mt-1 border-radius-lg ">
        <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 bg-white mt-3 border-radius-xl" id="navbarBlur">
            <div class="container-fluid py-1 px-3">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 text-truncate">
                        <li class="breadcrumb-item text-sm text-capitalize text-truncate" v-for=" (path, index) in this.$route.name.split('.')" v-bind:key="index">{{ path.replace('-', ' ') }}</li>
                    </ol>
                    <h6 class="fw-bolder text-capitalize mb-0">{{ this.$route.name.split('.')[this.$route.name.split('.').length - 1].replace('-', ' ') }}</h6>
                </nav>
                <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
                    <div class="ms-md-auto pe-md-3 d-flex align-items-center"></div>
                    <ul class="navbar-nav justify-content-end">
                        <li class="nav-item d-flex align-items-center">
                            <a href="javascript:;" class="nav-link text-body font-weight-bold px-0">
                                <span class="d-sm-inline d-none">{{ this.name }}</span> &nbsp; <i class="fa fa-user me-sm-1"></i>
                            </a>
                        </li>
                        <li class="nav-item px-2">
                            <router-link :to="{ name: 'auth.guest' }" class="nav-link pe-0">
                                <font-awesome-icon icon="home"></font-awesome-icon>
                            </router-link>
                        </li>
                        <li class="nav-item d-xl-none px-2 d-flex align-items-center">
                            <a href="javascript:;" @click="toggleSidebar" class="nav-link text-body p-0" id="iconNavbarSidenav">
                                <div class="sidenav-toggler-inner">
                                    <i class="sidenav-toggler-line"></i>
                                    <i class="sidenav-toggler-line"></i>
                                    <i class="sidenav-toggler-line"></i>
                                </div>
                            </a>
                        </li>
                        <li class="nav-item" v-if="!roles.Guest">
                            <a href="javascript:;" class="nav-link pe-0">
                                <font-awesome-icon icon="sign-out" @click="signOut"></font-awesome-icon>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="container-fluid py-4 min-vh-80 pb-5">
            <router-view />
        </div>
    </main>
</template>

<script>
import Sidebar from '@/views/layouts/Sidebar.vue';

export default {
    name: "layout",
    components: { Sidebar },
    data() {
        return {
            appTitle: process.env.VUE_APP_TITLE,
            baseUrl: process.env.VUE_APP_URL,
            roles: {
                Guest: true
            },
            name: ''
        }
    },
    methods: {
        toggleSidebar() {
            const sidenav_show = document.querySelector(".g-sidenav-show");
            if (sidenav_show.classList.contains("g-sidenav-hidden")) {
                sidenav_show.classList.remove("g-sidenav-hidden");
                sidenav_show.classList.add("g-sidenav-pinned");
            } else {
                sidenav_show.classList.add("g-sidenav-hidden");
                sidenav_show.classList.remove("g-sidenav-pinned");
            }
        },
        signOut() {
            const sidenav_show = document.querySelector(".g-sidenav-show");
            sidenav_show.classList.add("g-sidenav-hidden");
            sidenav_show.classList.remove("g-sidenav-pinned");

            let self = this;
            this.$swal.fire({
                title: 'Keluar',
                text: 'Kamu akan mengeluarkan akunmu dari aplikasi?',
                showCancelButton: true,
                cancelButtonText: 'Batal'
            }).then(function (result) {
                if (result.isConfirmed) {
                    window.localStorage.clear();
                    self.axios.defaults.headers.common = { Authorization: `Bearer ${localStorage.getItem('bearerToken')}` };
                    self.$router.push({ name: 'auth.guest' });
                }
            });
        }
    },
    mounted() {
        this.axios.get('biodata').then((response) => {
            if (response.data.data) {
                this.roles = {};
                window.localStorage.setItem('name', response.data.data[0].name);
                window.localStorage.setItem('user_id', response.data.data[0].id);
                this.name = response.data.data[0].name;
                response.data.data[0].roles.forEach((role) => {
                    this.roles[role.name] = true;
                });
            } else {
                this.name = 'Pemohon';
                this.roles = { Guest: true };
            }
        });
    }
};
</script>